import { render, staticRenderFns } from "./Scores.vue?vue&type=template&id=3681c1ee"
import script from "./Scores.vue?vue&type=script&lang=js"
export * from "./Scores.vue?vue&type=script&lang=js"
import style0 from "./Scores.vue?vue&type=style&index=0&id=3681c1ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports